import React, { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import {
  checkEmptySpaces,
  maxLength,
  Required,
} from "../../../../utils/patterns";
import { useNavigate } from "react-router";
// import VenueLocationOtp from "../../account-setup/venue-location/VenueLocationOtp";
import { useUser } from "../../../../providers/UserContext";
import TextInput from "../../../../components/common/input-field/TextInput";
import SelectField from "../../../../components/common/select-field/SelectField";
import NumberInput from "../../../../components/common/number-field/NumberInput";
import ThemeDatePicker from "../../../../components/common/date-picker/ThemeDatePicker";
import { MdOutlineCalendarMonth } from "react-icons/md";

export default function PersonalInfo() {
  const [privacyModal, setPrivacyModal] = useState(false);
  const [termsModal, setTermsModal] = useState(false);
  const [otp, setOtp] = useState(false);
  const [sucessModal, setSucessModal] = useState(false);
  const [verifyDone, setVerifyDone] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const { setFirstLogin, firstLogin } = useUser();

  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    control,
    clearErrors,
    watch,
  } = useForm({
    mode: "onChange",
  });
  const onSubmit = async (data) => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
      setOtp(true);
      setFirstLogin(true);

      navigate("/otp-verfication-password", {
        state: { redirect: "/account-created", hello: "hello" },
      });
    }, 2000);
  };
  const password = useRef({});
  password.current = watch("password", "");
  const gender = [
    {
      value: 1,
      label: "Male",
    },
    {
      value: 2,
      label: "Female",
    },
    {
      value: 3,
      label: "Other",
    },
  ];

  const countryType = [
    { value: 1, label: "USA" },
    { value: 2, label: "Dubai" },
  ];
  const state = [
    { value: 1, label: "California" },
    { value: 2, label: "Texas" },
  ];

  return (
    <div className={"signup"}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className={"dfields"}>
          <Controller
            name="dob"
            defaultValue={""}
            control={control}
            rules={{ required: Required }}
            render={({ field: { name, ...field } }) => (
              <ThemeDatePicker
                label={"Date"}
                fieldName={name}
                className={"required"}
                setValue={setValue}
                errors={errors.dob}
                placeholder={"Select Date"}
                format={"MMM DD, YYYY"}
                suffix={<MdOutlineCalendarMonth />}
              />
            )}
          />
        </div>

        <div className={"dfields"}>
          <Controller
            name="country"
            defaultValue={""}
            control={control}
            rules={{ required: Required }}
            render={({ field: { name, ...field } }) => (
              <SelectField
                showSearch={true}
                label={"Country"}
                field={field}
                placeholder={"Select Country"}
                className={"required"}
                options={countryType}
                errors={errors.country}
                fieldName={name}
                setValue={setValue}
              />
            )}
          />
        </div>

        <div className={"dfields"}>
          <Controller
            name="address"
            defaultValue={""}
            control={control}
            rules={{
              required: Required,
              maxLength: maxLength(100),
              validate: checkEmptySpaces,
            }}
            render={({ field: { name, ...field } }) => (
              <TextInput
                placeholder={"Address"}
                label={"Address"}
                type={"text"}
                field={field}
                errors={errors.address}
                className={"required"}
              />
            )}
          />
        </div>

        <div className={"dfields"}>
          <Controller
            name="state"
            defaultValue={""}
            control={control}
            rules={{ required: Required }}
            render={({ field: { name, ...field } }) => (
              <SelectField
                showSearch={true}
                label={"City/State"}
                field={field}
                placeholder={"Select City/State"}
                className={"required"}
                options={state}
                errors={errors.state}
                fieldName={name}
                setValue={setValue}
              />
            )}
          />
        </div>

        <div className={"dfields"}>
          <Controller
            name="z_code"
            defaultValue={""}
            control={control}
            rules={{ required: Required, maxLength: maxLength(10) }}
            render={({ field: { name, ...field } }) => (
              <NumberInput
                placeHolder={"Zip Code"}
                label={"Zip Code"}
                field={field}
                className={"required"}
                errors={errors.z_code}
                clearError={clearErrors}
                setValue={setValue}
                sign={""}
                fieldName={name}
              />
            )}
          />
        </div>

        {/*<div className={'dfields'} style={{marginTop:38}}>*/}
        {/*    <ThemeButton*/}
        {/*        text={'Sign up'}*/}
        {/*        className={'btn-light-lg'}*/}
        {/*        type={'submit'}*/}
        {/*        loader={loader}*/}
        {/*    />*/}
        {/*</div>*/}
      </Form>
    </div>
  );
}
